import React, { useEffect, useState } from 'react';
import {
    Form,
    Input,
    InputNumber,
    Select,
    Checkbox,
    Row,
    Col,
    message,
    DatePicker,
    Divider,
    Spin,
} from 'antd';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import AppLayout from '../../components/AppLayout';

const { RangePicker } = DatePicker;

const productTypes = [
    { label: 'Stockable', value: 'stockable' },
    { label: 'Consumable', value: 'consumable' },
    { label: 'Service', value: 'service' },
];

const units = ['pcs', 'kg', 'litre', 'meter'];

const AddProductForm: React.FC = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { id } = useParams();

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/categories`).then((res) => setCategories(res.data));

        if (id) {
            setLoading(true);
            axios.get(`${process.env.REACT_APP_API_URL}/inventory/${id}`)
                .then((res) => {
                    form.setFieldsValue(res.data);
                })
                .catch(() => {
                    message.error('Failed to load product');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [id]);

    const handleSubmit = async (values: any) => {
        try {
            if (id) {
                await axios.patch(`${process.env.REACT_APP_API_URL}/inventory/${id}`, values);
                message.success('Product updated');
            } else {
                await axios.post(`${process.env.REACT_APP_API_URL}/inventory`, values);
                message.success('Product added');
            }
            navigate('/inventory/products');
        } catch {
            message.error('Failed to save product');
        }
    };

    return (
        <AppLayout>
            <Spin spinning={loading}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16, gap: 8 }}>
              <button onClick={() => navigate('/inventory/products')} style={{ padding: '6px 16px', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                Cancel
              </button>
              <button onClick={() => form.submit()} style={{ padding: '6px 16px', backgroundColor: '#1890ff', color: '#fff', border: 'none', borderRadius: 4 }}>
                Save
              </button>
            </div>
            <h3>{id ? 'Edit Product' : 'Add Product'}</h3>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="name" label="Product Name" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="sku" label="SKU" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="category" label="Category">
                            <Select options={categories.map((c: any) => ({ label: c.name, value: c.name }))} />
                        </Form.Item>

                    </Col>
                    <Col span={12}>
                        <Form.Item name="product_type" label="Product Type" rules={[{ required: true }]}>
                            <Select options={productTypes} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="cost_price" label="Cost Price">
                            <InputNumber min={0} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="sale_price" label="Sale Price">
                            <InputNumber min={0} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="hsn_sac" label="HSN/SAC Code">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="barcode" label="Barcode">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="unit" label="Unit" rules={[{ required: true }]}>
                            <Select options={units.map(u => ({ label: u, value: u }))} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="stock" label="Stock Quantity">
                            <InputNumber min={0} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item name="is_sellable" valuePropName="checked">
                            <Checkbox>Sellable</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="is_purchasable" valuePropName="checked">
                            <Checkbox>Purchasable</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="is_expense" valuePropName="checked">
                            <Checkbox>Expense</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="is_manufactured" valuePropName="checked">
                            <Checkbox>Manufacturable</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>

    

                {/* <Divider orientation="left">Manufacturing Info</Divider>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="workstation" label="Workstation">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="supervisor" label="Supervisor">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="production_timeline" label="Production Timeline">
                            <RangePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row> */}
            </Form>
            </Spin>
        </AppLayout>
    );
};

export default AddProductForm;
